import React from "react";
import { Link } from "gatsby";
import cx from "classnames";
import { IoArrowForwardSharp, IoArrowBackSharp } from "react-icons/io5";

export function LinkButton(props) {
  return (
    <Link {...props}>
      <div className="label">
        <p className="text">{props.name}</p>
      </div>

      <div className="circlewrap">
        <div className="circle" />
        <div className="arrow">
          <IoArrowForwardSharp className="icon" />
        </div>
      </div>
    </Link>
  );
}

export function ActionButton({ isPending, icon, name, ...buttonProps }) {
  return (
    <button {...buttonProps}>
      <div className="label">
        <p className="text">{isPending ? "Отправка" : name}</p>
      </div>

      <div className="circlewrap">
        <div className="circle" />
        <div className="arrow">{icon}</div>
      </div>
    </button>
  );
}

export function WideButton(props) {
  return (
    <button {...props}>
      <div className="label">
        <p className="text">{props.name}</p>
      </div>

      <div className="circlewrap">
        <div className="circle" />
        <div className="arrow">{props.icon}</div>
      </div>
    </button>
  );
}

export function BackButton(props) {
  return (
    <button
      className={cx("round-simple back", props.hidden && "hidden")}
      onClick={props.onClick}
    >
      <IoArrowBackSharp className="icon" />
      <IoArrowBackSharp className="hiddenicon" />
    </button>
  );
}

export function NextButton(props) {
  return (
    <button
      className={cx("round-simple next", props.hidden && "hidden")}
      onClick={props.onClick}
    >
      <IoArrowForwardSharp className="icon" />
      <IoArrowForwardSharp className="hiddenicon" />
    </button>
  );
}
